// Whether an assessment question has been answered: a pick on a choice question,
// non-blank text on a written response, and nothing to answer on a question that
// offers neither.
//
// Shared by the two controllers on the assessment form — the completeness validator
// that blocks a submit, and the Evaluation walkthrough that gates its Submit button —
// so the two can never reach different verdicts on the same question.
export function assessmentQuestionAnswered(question) {
  const choiceInputs = question.querySelectorAll(".academy-quiz-option-input")
  if (choiceInputs.length > 0) {
    return Array.from(choiceInputs).some((input) => input.checked)
  }

  const openInput = question.querySelector(".academy-quiz-open-input")
  return openInput ? openInput.value.trim() !== "" : true
}
